let audioCtx = null;

function getCtx() {
  if (audioCtx) return audioCtx;
  const Ctx = window.AudioContext || window.webkitAudioContext;
  if (!Ctx) return null;
  audioCtx = new Ctx();
  return audioCtx;
}

async function safeResume(ctx) {
  try {
    if (ctx?.state === "suspended") await ctx.resume();
  } catch (_e) {}
}

function tone({ freq = 440, durationMs = 70, gain = 0.03, type = "sine", detune = 0 } = {}) {
  const ctx = getCtx();
  if (!ctx) return;

  const startAt = ctx.currentTime;
  const durationSec = durationMs / 1000;

  const osc = ctx.createOscillator();
  osc.type = type;
  osc.frequency.setValueAtTime(freq, startAt);
  osc.detune.setValueAtTime(detune, startAt);

  const g = ctx.createGain();
  g.gain.setValueAtTime(0.0001, startAt);
  g.gain.exponentialRampToValueAtTime(gain, startAt + 0.01);
  g.gain.exponentialRampToValueAtTime(0.0001, startAt + durationSec);

  osc.connect(g);
  g.connect(ctx.destination);

  osc.start(startAt);
  osc.stop(startAt + durationSec + 0.02);
}

export async function playFeedbackTone(stage) {
  const ctx = getCtx();
  if (!ctx) return;
  await safeResume(ctx);

  if (stage === "pressed") {
    tone({ freq: 520, durationMs: 45, gain: 0.03, type: "triangle" });
    return;
  }
  if (stage === "local") {
    tone({ freq: 720, durationMs: 45, gain: 0.03, type: "sine" });
    window.setTimeout(() => tone({ freq: 980, durationMs: 55, gain: 0.026, type: "sine" }), 55);
    return;
  }
  if (stage === "db") {
    tone({ freq: 660, durationMs: 60, gain: 0.03, type: "sine" });
    window.setTimeout(() => tone({ freq: 990, durationMs: 85, gain: 0.028, type: "triangle" }), 65);
    return;
  }
  if (stage === "error") {
    // two quick low tones
    tone({ freq: 220, durationMs: 85, gain: 0.035, type: "square" });
    window.setTimeout(() => tone({ freq: 160, durationMs: 95, gain: 0.03, type: "square" }), 95);
    return;
  }
}

